export default __webpack_public_path__ + "static/media/edit.7f031d62.svg";